(() => {
	angular.module('main').controller('ProfileController', ProfileController);

	ProfileController.$inject = [];

	function ProfileController() {}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/profileController.js